import React, { useState, useEffect } from 'react';
import Card from '../components/ui/Card';
import Button from '../components/ui/Button';
import { offerService } from '../services/offerService';
import { couponService } from '../services/couponService';
import './Offers.css';

// 🌈 CATEGORIES D'OFFRES
const OFFER_CATEGORIES = [
  { id: 'financial', name: 'Support financier', icon: '💰', color: '#4ecdc4' },
  { id: 'family', name: 'Famille & éducation', icon: '👨‍👩‍👧‍👦', color: '#ff9f43' },
  { id: 'shopping', name: 'Achats courants', icon: '🛍️', color: '#a29bfe' },
  { id: 'leisure', name: 'Voyages & loisirs', icon: '🌴', color: '#1dd1a1' },
  { id: 'health', name: 'Santé', icon: '🏥', color: '#48dbfb' },
  { id: 'food', name: 'Restauration', icon: '🍽️', color: '#ff6b6b' },
  { id: 'religious', name: 'Vie spirituelle', icon: '🕋', color: '#6c5ce7' },
  { id: 'wellness', name: 'Sport & bien-être', icon: '🧘', color: '#feca57' },
  { id: 'training', name: 'Formation pro', icon: '💼', color: '#10ac84' },
  { id: 'culture', name: 'Culture', icon: '🎭', color: '#ee5253' },
];

// 🎯 TYPES D'OFFRES
const OFFER_TYPES = [
  { id:'discount',     name:'Réduction',     icon:'🏷️', color:'#667eea' },
  { id:'voucher',      name:'Bon / Coupon',  icon:'🧾', color:'#feca57' },
  { id:'cash_support', name:'Prise en charge',icon:'🏛️', color:'#00b894' },
  { id:'credit',       name:'Crédit / Paiement', icon:'💳', color:'#54a0ff' },
  { id:'gift',         name:'Cadeau',        icon:'🎁', color:'#ff9ff3' },
  { id:'access',       name:'Accès VIP',     icon:'🔑', color:'#5f27cd' },
  { id:'event',        name:'Événement',     icon:'🎟️', color:'#48dbfb' },
  { id:'logistics',    name:'Livraison / Promo', icon:'🚚', color:'#96ceb4' },
];

// 🔧 CONFIGURATION DES ACTIONS PAR TYPE
const OFFER_SYSTEMS_CONFIG = {
  // 🎫 TYPES AVEC COUPONS
  voucher: { hasCoupons: true },
  access: { hasCoupons: true },
  gift: { hasCoupons: true },
  
  // 🎯 TYPES SANS COUPONS
  discount: { hasCoupons: false },
  logistics: { hasCoupons: false },
  event: { hasCoupons: false },
  cash_support: { hasCoupons: false },
  credit: { hasCoupons: false }
};
// 🎫 Composant pour afficher les statistiques réelles des coupons
const CouponStats = ({ offerId }) => {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        setLoading(true);
        const couponsData = await couponService.getAdminCoupons(offerId);
        setCoupons(couponsData.data || couponsData || []);
      } catch (err) {
        setError('Erreur lors du chargement des coupons');
        console.error('Erreur fetch coupons:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCoupons();
  }, [offerId]);

  // Calcul des statistiques réelles
  const stats = {
    total: coupons.length,
    used: coupons.filter(c => c.status === 'used').length,
    active: coupons.filter(c => c.status === 'active').length,
    expired: coupons.filter(c => c.status === 'expired').length
  };

  if (loading) {
    return (
      <>
        <div className="detail-item">
          <label>Chargement des statistiques...</label>
          <span>⏳</span>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <div className="detail-item full-width">
        <label>Erreur:</label>
        <span className="error-text">{error}</span>
      </div>
    );
  }

  return (
    <>
      <div className="detail-item">
        <label>Coupons totaux:</label>
        <span>{stats.total}</span>
      </div>
      <div className="detail-item">
        <label>Coupons utilisés:</label>
        <span>{stats.used}</span>
      </div>
      <div className="detail-item">
        <label>Coupons disponibles:</label>
        <span className="available-highlight">
          {stats.active}
        </span>
      </div>
      <div className="detail-item">
        <label>Coupons expirés:</label>
        <span>{stats.expired}</span>
      </div>
      <div className="detail-item">
        <label>Taux d'utilisation:</label>
        <span>
          {stats.total > 0 ? Math.round((stats.used / stats.total) * 100) : 0}%
        </span>
      </div>
    </>
  );
};
// 🎨 Composant Modal pour les détails
const OfferDetailsModal = ({ offer, onClose }) => {
  if (!offer) return null;

  const categoryInfo = OFFER_CATEGORIES.find(cat => cat.id === offer.category) || OFFER_CATEGORIES[0];
  const typeInfo = OFFER_TYPES.find(type => type.id === offer.type) || OFFER_TYPES[0];

   return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {/* En-tête de la modal */}
        <div className="modal-header">
          <h2>Détails de l'offre</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
        {/* 🔥 AJOUT: Afficher l'image si elle existe */}
          {offer.imageUrl && (
            <div className="offer-image-section">
              <div className="offer-image-container">
                <img 
                  src={offer.imageUrl} 
                  alt={offer.title}
                  className="offer-detail-image"
                />
              </div>
            </div>
          )}


          {/* Section Principale */}
          <div className="details-section">
            <h3>Informations principales</h3>
            <div className="details-grid">
              <div className="detail-item">
                <label>Titre:</label>
                <span>{offer.title}</span>
              </div>
              <div className="detail-item">
                <label>Code offre:</label>
                <span className="code-value">{offer.codeOffre}</span>
              </div>
              <div className="detail-item">
                <label>Catégorie:</label>
                <span>
                  <span className="category-icon">{categoryInfo.icon}</span>
                  {categoryInfo.name}
                </span>
              </div>
              <div className="detail-item">
                <label>Type:</label>
                <span>
                  <span className="type-icon">{typeInfo.icon}</span>
                  {typeInfo.name}
                </span>
              </div>
              {offer.discount && (
              <div className="detail-item">
                <label>Avantage:</label>
                <span className="discount-highlight">{offer.discount}</span>
              </div>
            )}
              <div className="detail-item">
                <label>Statut:</label>
                <span className={`status ${offer.isActive ? 'active' : 'inactive'}`}>
                  {offer.isActive ? '🟢 Active' : '🔴 Inactive'}
                </span>
              </div>
              <div className="detail-item">
                <label>Exclusive:</label>
                <span>{offer.isExclusive ? '👑 Oui' : '🌍 Non'}</span>
              </div>
            </div>
          </div>

          {/* Description complète */}
          <div className="details-section">
            <h3>Description</h3>
            <p className="full-description">{offer.description}</p>
          </div>

          {/* Partenaire */}
          <div className="details-section">
            <h3>Partenaire</h3>
            <div className="details-grid">
              <div className="detail-item">
                <label>Nom du partenaire:</label>
                <span>{offer.partnerName}</span>
              </div>
            </div>
          </div>

          {/* Entreprises autorisées */}
          {offer.isExclusive && offer.forCompanies && offer.forCompanies.length > 0 && (
            <div className="details-section">
              <h3>Entreprises autorisées</h3>
              <div className="companies-list">
                {offer.forCompanies.length}
              </div>
            </div>
          )}

          {/* Gestion des coupons */}
          {offer.hasCoupons && (
          <div className="details-section">
            <h3>Gestion des coupons</h3>
            <div className="details-grid">
              <div className="detail-item">
                <label>Système de coupons:</label>
                <span>{offer.hasCoupons ? '🎫 Activé' : '🚫 Désactivé'}</span>
              </div>
              
                <>
                  <CouponStats offerId={offer._id} />
                </>
              
            </div>
          </div>
          )}

          {/* Contribution employeur */}
          {(offer.employerContribution > 0 || offer.maxAmount > 0) && (
            <div className="details-section">
              <h3>Contribution employeur</h3>
              <div className="details-grid">
                {offer.employerContribution > 0 && (
                  <div className="detail-item">
                    <label>Contribution:</label>
                    <span>{offer.employerContribution}%</span>
                  </div>
                )}
                {offer.maxAmount > 0 && (
                  <div className="detail-item">
                    <label>Montant maximum:</label>
                    <span>{offer.maxAmount} DA</span>
                  </div>
                )}
                {offer.maxDuration > 0 && (
                  <div className="detail-item">
                    <label>Durée maximum:</label>
                    <span>{offer.maxDuration} mois</span>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Localisation */}
          {offer.hasAddress && (
            <div className="details-section">
              <h3>Localisation</h3>
              <div className="details-grid">
                <div className="detail-item full-width">
                  <label>Adresse:</label>
                  <span>{offer.address}</span>
                </div>

                {offer.geolocalisation && (
                  <div className="detail-item full-width">
                  <label>Localisation:</label>
                      <Button 
                        variant="primary" 
                        size="sm"
                        onClick={() => {
                          // Ouvre Google Maps avec les coordonnées GPS

                          const coords = offer.geolocalisation.replace("geo:", ""); 
                          window.open(`https://www.google.com/maps?q=${coords}`, '_blank');
                        }}
                      >
                      📍 Voir sur Google Maps
                      </Button>
                    </div>
                  )}

              </div>
            </div>
          )}






          {/* Conditions d'utilisation */}
          {offer.conditions && offer.conditions.length > 0 && (
            <div className="details-section">
              <h3>Conditions d'utilisation</h3>
              <ul className="conditions-list">
                {offer.conditions.map((condition, index) => (
                  <li key={index}>{condition}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Instructions d'utilisation */}
          {offer.usageInstructions && offer.usageInstructions.length > 0 && (
            <div className="details-section">
              <h3>Instructions d'utilisation</h3>
              <ul className="instructions-list">
                {offer.usageInstructions.map((instruction, index) => (
                  <li key={index}>{instruction}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Dates et métadonnées */}
          <div className="details-section">
            <h3>Dates et métadonnées</h3>
            <div className="details-grid">
              <div className="detail-item">
                <label>Date de début:</label>
                <span>{new Date(offer.startDate).toLocaleDateString('fr-FR')}</span>
              </div>
              <div className="detail-item">
                <label>Date de fin:</label>
                <span>{new Date(offer.endDate).toLocaleDateString('fr-FR')}</span>
              </div>
              <div className="detail-item">
                <label>Créée le:</label>
                <span>{new Date(offer.createdAt).toLocaleDateString('fr-FR')}</span>
              </div>
              <div className="detail-item">
                <label>Modifiée le:</label>
                <span>{new Date(offer.updatedAt).toLocaleDateString('fr-FR')}</span>
              </div>
              <div className="detail-item">
                <label>Note utilisateurs:</label>
                <span>⭐ {offer.userRating}/5</span>
              </div>
            </div>
          </div>
        </div>

        {/* Pied de la modal */}
        <div className="modal-footer">
          <Button variant="secondary" onClick={onClose}>
            Fermer
          </Button>
        </div>
      </div>
    </div>
  );
};


// 🎫 Composant Modal pour les coupons
// 🎫 Composant Modal pour les coupons
const CouponsModal = ({ offer, coupons, onClose }) => {
  if (!offer) return null;

  // S'assurer que coupons est un tableau
  const couponsList = Array.isArray(coupons) ? coupons : [];

  // Statistiques des coupons
  const stats = {
    total: couponsList.length,
    active: couponsList.filter(c => c.status === 'active').length,
    used: couponsList.filter(c => c.status === 'used').length,
    expired: couponsList.filter(c => c.status === 'expired').length
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        {/* En-tête de la modal */}
        <div className="modal-header">
          <h2>🎫 Gestion des coupons</h2>
          <div className="modal-subtitle">{offer.title}</div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          {/* Statistiques des coupons */}
          <div className="coupons-stats">
            <div className="stat-item">
              <div className="stat-number total">{stats.total}</div>
              <div className="stat-label">Total générés</div>
            </div>
            <div className="stat-item">
              <div className="stat-number active">{stats.active}</div>
              <div className="stat-label">Disponibles</div>
            </div>
            <div className="stat-item">
              <div className="stat-number used">{stats.used}</div>
              <div className="stat-label">Utilisés</div>
            </div>
            <div className="stat-item">
              <div className="stat-number expired">{stats.expired}</div>
              <div className="stat-label">Expirés</div>
            </div>
          </div>

          {/* Liste des coupons */}
          <div className="coupons-list">
            <h3>Détail des coupons</h3>
            
            {couponsList.length === 0 ? (
              <div className="empty-coupons">
                <div className="empty-icon">🎫</div>
                <p>Aucun coupon généré pour cette offre</p>
                <small>Les coupons sont créés automatiquement quand l'offre est activée</small>
              </div>
            ) : (
              <div className="coupons-table">
                <div className="table-header">
                  <div className="col-code">Code coupon</div>
                  <div className="col-status">Statut</div>
                  <div className="col-user">Utilisateur</div>
                  <div className="col-date">Date utilisation</div>
                  <div className="col-expiry">Expiration</div>
                </div>
                
                <div className="table-body">
                  {couponsList.map((coupon) => (
                    <div key={coupon._id} className={`table-row ${coupon.status}`}>
                      <div className="col-code">
                        <span className="coupon-code">{coupon.code}</span>
                      </div>
                      <div className="col-status">
                        <span className={`status-badge ${coupon.status}`}>
                          {coupon.status === 'active' && '🟢 Actif'}
                          {coupon.status === 'used' && '✅ Utilisé'}
                          {coupon.status === 'expired' && '🔴 Expiré'}
                        </span>
                      </div>
                      <div className="col-user">
                        {coupon.userId ? (
                          <span className="user-info">
                            {/* Ton API devrait retourner user.firstName et user.lastName */}
                            {coupon.user?.firstName || 'Utilisateur'} {coupon.user?.lastName || ''}
                            <br />
                            <small>{coupon.user?.employeeId || coupon.userId}</small>
                          </span>
                        ) : (
                          <span className="not-assigned">Non attribué</span>
                        )}
                      </div>
                      <div className="col-date">
                        {coupon.usedAt 
                          ? new Date(coupon.usedAt).toLocaleDateString('fr-FR')
                          : '-'
                        }
                      </div>
                      <div className="col-expiry">
                        {new Date(coupon.expiresAt).toLocaleDateString('fr-FR')}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

      
        </div>

        {/* Pied de la modal */}
        <div className="modal-footer">
          <Button variant="primary" onClick={onClose}>
            Fermer
          </Button>
        </div>
      </div>
    </div>
  );
};
const Offers = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedOfferType, setSelectedOfferType] = useState('all');
  const [selectedOffer, setSelectedOffer] = useState(null); // Pour la modal
  const [selectedCoupons, setSelectedCoupons] = useState(null); // Pour la modal coupons

  // Charger les offres avec l'API admin
  const fetchOffers = async () => {
    try {
      setLoading(true);
      setError('');
      const data = await offerService.getPartnerOffers({
        category: selectedCategory !== 'all' ? selectedCategory : null,
        type: selectedOfferType !== 'all' ? selectedOfferType : null
      });
      setOffers(data || []);
    } catch (err) {
      setError(err.message || 'Erreur lors du chargement des offres');
      console.error('Erreur fetch offers:', err);
    } finally {
      setLoading(false);
    }
  };

  // Chargement initial
  useEffect(() => {
    fetchOffers();
  }, []);

  // Rechargement quand les filtres changent
  useEffect(() => {
    fetchOffers();
  }, [selectedCategory, selectedOfferType]);

  const getCategoryInfo = (categoryId) => {
    return OFFER_CATEGORIES.find(cat => cat.id === categoryId) || OFFER_CATEGORIES[0];
  };

  const getTypeInfo = (typeId) => {
    return OFFER_TYPES.find(type => type.id === typeId) || OFFER_TYPES[0];
  };

  // ✅ Détermine la logique métier selon le type
  const getOfferSystem = (offerType) => {
    return OFFER_SYSTEMS_CONFIG[offerType] || { hasCoupons: false };
  };

  const filteredOffers = offers.filter(offer => {
    const categoryMatch = selectedCategory === 'all' || offer.category === selectedCategory;
    const typeMatch = selectedOfferType === 'all' || offer.type === selectedOfferType;
    return categoryMatch && typeMatch;
  });
  const handleCloseCouponsModal = () => {
    setSelectedCoupons(null);
  };
  // ✅ CONSULTER les coupons d'une offre
// ✅ CONSULTER les coupons d'une offre (DÉVELOPPÉ)



  // ✅ CONSULTER les coupons d'une offre (DÉVELOPPÉ)
  const handleViewCoupons = async (offerId) => {
    try {
      setLoading(true);
      const offer = offers.find(o => o._id === offerId);
      
      if (!offer) {
        setError('Offre non trouvée');
        return;
      }

      // Appel à l'API pour récupérer les coupons AVEC les infos utilisateurs
      const couponsData = await couponService.getAdminCoupons(offerId);
      
      // Ouvre la modal avec les données
      setSelectedCoupons({
        offer: offer,
        coupons: couponsData.data || couponsData || [] // S'adapte selon la structure de réponse
      });
      
    } catch (err) {
      setError(err.message || 'Erreur lors de la récupération des coupons');
      console.error('Erreur consultation coupons:', err);
    } finally {
      setLoading(false);
    }
  };
  
  // ✅ Voir les détails de l'offre (DÉVELOPPÉ)
  const handleViewDetails = (offerId) => {
    const offer = offers.find(o => o._id === offerId);
    if (offer) {
      setSelectedOffer(offer);
    }
  };

  // Fermer la modal
  const handleCloseModal = () => {
    setSelectedOffer(null);
  };

  if (loading) {
    return (
      <div className="offers">
        <div className="page-header">
          <div className="page-title">
            <h1>Gestion des Offres</h1>
            <p>Chargement...</p>
          </div>
        </div>
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Chargement des offres...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="offers">
      {/* En-tête de page */}
      <div className="page-header">
        <div className="page-title">
          <h1>Gestion des Offres</h1>
          <p>Consultez vos offres</p>
        </div>
        
        <div className="header-actions">
          <div className="filters">
            <select 
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className="filter-select"
            >
              <option value="all">Toutes les catégories</option>
              {OFFER_CATEGORIES.map(category => (
                <option key={category.id} value={category.id}>
                  {category.icon} {category.name}
                </option>
              ))}
            </select>

            <select 
              value={selectedOfferType}
              onChange={(e) => setSelectedOfferType(e.target.value)}
              className="filter-select"
            >
              <option value="all">Tous les types</option>
              {OFFER_TYPES.map(type => (
                <option key={type.id} value={type.id}>
                  {type.icon} {type.name}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* Message d'erreur */}
      {error && (
        <Card className="error-card" padding="md">
          <div className="error-message">
            <span>❌</span>
            {error}
            <button onClick={() => setError('')} className="error-close">✕</button>
          </div>
        </Card>
      )}

      {/* Statistiques rapides */}
      <div className="offers-stats">
        <Card className="stat-card" padding="lg">
          <div className="stat-content">
            <div className="stat-icon">📊</div>
            <div className="stat-info">
              <div className="stat-number">{offers.length}</div>
              <div className="stat-label">Offres totales</div>
            </div>
          </div>
        </Card>
        
        <Card className="stat-card" padding="lg">
          <div className="stat-content">
            <div className="stat-icon">✅</div>
            <div className="stat-info">
              <div className="stat-number">
                {offers.filter(o => o.isActive).length}
              </div>
              <div className="stat-label">Offres actives</div>
            </div>
          </div>
        </Card>
        
        <Card className="stat-card" padding="lg">
          <div className="stat-content">
            <div className="stat-icon">👑</div>
            <div className="stat-info">
              <div className="stat-number">
                {offers.filter(o => o.isExclusive).length}
              </div>
              <div className="stat-label">Offres exclusives</div>
            </div>
          </div>
        </Card>
      </div>

      {/* Grille des offres */}
      <div className="offers-grid">
        {filteredOffers.map(offer => {
          const categoryInfo = getCategoryInfo(offer.category);
          const typeInfo = getTypeInfo(offer.type);
          const offerSystem = getOfferSystem(offer.type);
          
          const hasCoupons = offerSystem.hasCoupons && offer.hasCoupons && offer.totalCoupons > 0;
          
          return (
            <Card key={offer._id} className="offer-card" padding="lg">
              {/* En-tête de l'offre */}
              <div className="offer-header">
                <div className="offer-category">
                  <span className="category-icon">{categoryInfo.icon}</span>
                  <span className="category-name">{categoryInfo.name}</span>
                </div>
                <div className="offer-badges">
                  {offer.isExclusive && (
                    <span className="exclusive-badge">👑 Exclusive</span>
                  )}
                </div>
              </div>

              {/* Titre et code */}
              <div className="offer-title-section">
                <h3 className="offer-title">{offer.title}</h3>
              </div>

              {/* Description courte */}
              <p className="offer-description">
                {offer.description.length > 120 
                  ? `${offer.description.substring(0, 120)}...` 
                  : offer.description
                }
              </p>

              {/* Type et avantage principal */}
              <div className="offer-type-section">
                <span 
                  className="type-badge" 
                  style={{ 
                    backgroundColor: typeInfo.color,
                    color: 'white'
                  }}
                >
                  {typeInfo.icon} {typeInfo.name}
                </span>
                <span className="discount-badge type-primary">
                  {offer.discount}
                </span>
              </div>



              {/* ✅ Section COUPONS - Seulement pour les offres avec coupons */}
              {hasCoupons && (
                <div className="offer-usage">
                  <div className="usage-info">
                    <span className="available-coupons">
                      {offer.totalCoupons } coupons générés en total pour cette offre
                    </span>
                  </div>
                </div>
              )}

              {/* ✅ ACTIONS ADMIN */}
              <div className="offer-actions">
                {/* Bouton Voir détails - Toujours présent */}
                <Button 
                  variant="secondary" 
                  size="sm"
                  onClick={() => handleViewDetails(offer._id)}
                >
                  👁️ Voir détails
                </Button>
                
                {/* ✅ CONSULTER LES COUPONS - Seulement pour les offres avec coupons */}
                {hasCoupons && (
                  <Button 
                    variant="mint" 
                    size="sm"
                    onClick={() => handleViewCoupons(offer._id)}
                  >
                    🎫 Voir les coupons
                  </Button>
                )}
              </div>
            </Card>
          );
        })}
      </div>

      {/* État vide */}
      {filteredOffers.length === 0 && !loading && (
        <Card className="empty-state">
          <div className="empty-icon">🔍</div>
          <h3 className="empty-title">Aucune offre trouvée</h3>
          <p className="empty-text">
            {offers.length === 0 
              ? "Aucune offre disponible pour le moment"
              : "Aucune offre ne correspond aux filtres sélectionnés"
            }
          </p>
          <Button 
            variant="primary"
            onClick={() => {
              setSelectedCategory('all');
              setSelectedOfferType('all');
            }}
          >
            📋 Voir toutes les offres
          </Button>
        </Card>
      )}

      {/* Modal des détails */}
      {selectedOffer && (
        <OfferDetailsModal 
          offer={selectedOffer} 
          onClose={handleCloseModal} 
        />
      )}


            {/* Modal des coupons */}
      {selectedCoupons && (
        <CouponsModal 
          offer={selectedCoupons.offer}
          coupons={selectedCoupons.coupons}
          onClose={handleCloseCouponsModal}
        />
      )}
    </div>
  );
};

export default Offers;